module.exports = __webpack_public_path__ + "img/IQ.4eae31eb.svg";